"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const siblingTreeLineStyle = core_1.css `
  stroke: transparent;
  stroke-width: 2;
`;
const SiblingTreeLine = ({ hasYoungerSibling, generation, hasAunt, }) => {
    const overallHeight = 40;
    const halfwayHeight = overallHeight / 2;
    const longLineHeight = hasYoungerSibling ? overallHeight : halfwayHeight;
    const width = generation * 25;
    const iconWidth = 10;
    const auntGenerationOffset = width - 35;
    return (core_1.jsx("svg", { css: siblingTreeLineStyle, height: overallHeight, width: width },
        generation > 1 && hasAunt && (core_1.jsx("line", { x1: auntGenerationOffset, x2: auntGenerationOffset, y1: 0, y2: overallHeight })),
        core_1.jsx("line", { x1: width - iconWidth, x2: width - iconWidth, y1: 0, y2: longLineHeight }),
        core_1.jsx("line", { x1: width - iconWidth, x2: width, y1: halfwayHeight, y2: halfwayHeight })));
};
exports.default = SiblingTreeLine;
